import { ENDPOINT } from 'api/endPoints/getCrossVersionsTrends';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM, MEDIUM_SHORT } from 'components/Dashboards/Reporting/reportingConfig';

export const trends: IHashmapItemComponentProps = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
    ],
    componentKey: 'trends',
    title: 'Trend Analysis Per Selected Parameters',
    id: 'trends',
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: MEDIUM,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    endpoint: ENDPOINT,
};
